import { BlueprintVersionedGroup } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from "ds/components/Table/Row/CellLabels";

const TemplatesTableLabelsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<BlueprintVersionedGroup>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={template.labels} />
    </TableSimpleCell>
  );
};

export default TemplatesTableLabelsCell;
